import script from "./list-api.vue?vue&type=script&setup=true&lang=js"
export * from "./list-api.vue?vue&type=script&setup=true&lang=js"

import "./list-api.vue?vue&type=style&index=0&id=3641f03b&scoped=true&lang=css"
import "./list-api.vue?vue&type=style&index=1&id=3641f03b&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3641f03b"]])

export default __exports__